import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

export class ModDynamicForm extends ModuleComponent{
    ready(){
        super.ready();
        this.$form = this.$root.find(".js-form");
        this.isSendingForm = false;

        this.findMember("submit").click(
            ()=>{
                this.$form.submit();
            }
        );

        this.$form.submit(
            (ev) => {
                ev.preventDefault();
                this.$form.checkRestrictions().then(
                    (isOk)=> {
                        if(isOk){
                            if(this.isSendingForm){
                                return;
                            }
                            let values = this.$form.getValues();
                            //clear all hidden fields
                            const $hiddenFields = $(this.$form.find(".js-form-field[data-applied-binding='hide']"));
                            $hiddenFields.each((index,item)=>{
                                delete values[$(item).data("name")];
                            });
                            this.isSendingForm = true;
                            GvfService.endpoint(
                                "/web/dynamic-form/send-form",
                                {formData: values}
                            ).then(
                                (resp) => {
                                    if(resp.message){
                                        this.findMember("web-card-inner").addClass("is-ok-message").html('<h2 class="text-center">'+resp.message+'</h2>');
                                    }
                                    if(resp.url){
                                        GvfService.delay(2000).then(
                                            ()=>{
                                                window.location = resp.url;
                                            }
                                        );
                                    }
                                }
                            ).catch(
                                (resp) => {
                                    UtilsService.alertEndpointResponse(resp);
                                }
                            ).finally(
                                ()=>{
                                    this.isSendingForm = false;
                                }
                            );
                        }else{
                            const position = this.$form.find(".web-form-field__error:visible").position();
                            if(typeof position !== 'undefined') {
                                this.findMember("web-card-inner").scrollTop(position.top);
                            }
                        }
                    }
                );
            });
    }
}
